export default events =>
  events
    .map(event => (typeof event === "string" ? event : Object.keys(event)[0]))
    .join(",");
